<form name="PostForm" (ngSubmit)="Validate(PostForm)" #PostForm="ngForm">
    <div class="card">
        <div class="card-header">
            <div class="card-title">
                Create Post
            </div>
        </div>
        <div class="card-body">
            <div class="row ms-1">
                <div class="col-auto">
                    <label>You are posting to : </label>
                </div>
                <div class="col-auto" style="min-width: 300px;">
                    <ng-select [items]="Postings" bindLabel="postingLabel" bindValue="postingLabel"
                        placeholder="Posting To" [(ngModel)]="FeedDetails.PostingTo">
                    </ng-select>
                </div>
            </div>

            <!-- <hr> -->

            <!-- <select [(ngModel)]="FeedDetails.PostingTo" #Title="ngModel" name="PostingTo">
                <option value="everyone">Everyone</option>
                <option value="Front">Front</option>
                <option value="Back">Back</option>
            </select> -->

            <div class="container pt-2">
                <input class="form-control" [(ngModel)]="FeedDetails.Title" #Title="ngModel" name="Title" type="text"
                    placeholder="Title here ...">
                <br>
                <textarea [(ngModel)]="FeedDetails.Description" #Description="ngModel" name="Description"
                    class="description" placeholder="Description here ..." rows="10" cols="60"></textarea>

                <div class="mt-1">
                    <!-- <div class="row">
                        <label class="col-sm-2 col-form-label" style="color: grey;">Add attachment :</label>
                        <label for="fileInput" class="btn btn-primary">
                            <i class="bi bi-paperclip" (click)="fileUpload.click()"></i>
                        </label>

                        <Input class="form-control attchment" (change)="upload($event, 'Feed')" #fileUpload
                            name="Attachment" accept=".jpeg,.jpg,.png" type="file" matTooltip="Choose File"
                            matTooltipClass="tooltip" />

                        <button class="btn btn-sm col-auto" name="delete" type="button" *ngIf="fileName" (click)="removeFile()">
                            <i class="bi bi-trash text-danger"></i>
                        </button>

                        <div class="col-auto" *ngIf="fileName">
                            {{fileName || "No file uploaded yet."}}
                        </div>
                    </div> -->

                    <div class="d-flex align-items-center gap-2 flex-wrap">
                        <label class="col-form-label mb-0" style="color: grey;">Add attachment:</label>

                        <label *ngIf="!fileName" for="fileInput" class="btn btn-primary mb-0">
                            <i class="bi bi-paperclip"></i>
                        </label>

                        <input #fileUpload id="fileInput" class="form-control form-control-sm attchment" type="file"
                            name="Attachment" accept=".jpeg,.jpg,.png" (change)="upload($event, 'Feed')"
                            matTooltip="Choose File" matTooltipClass="tooltip" style="width: auto; display: none;" />

                        <div class="mb-0" *ngIf="fileName">
                            <label>{{ fileName || "No file uploaded yet." }}</label>
                        </div>

                        <button (click)="viewDocument(fileUrl)" class="btn btn-sm btn-outline-primary" type="button" *ngIf="fileName">
                            <i class="bi bi-eye"></i>
                        </button>

                        <button class="btn btn-sm btn-outline-danger mb-0" type="button" name="delete" *ngIf="fileName"
                            (click)="removeFile()">
                            <i class="bi bi-trash"></i>
                        </button>
                    </div>

                </div>
            </div>

            <div class="d-flex pt-2 ms-2 mt-1">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="EnableLike"
                        [(ngModel)]="FeedDetails.EnableLike" #EnableLike="ngModel">
                    <label class="form-check-label" for="flexCheckDefault">
                        Enable Likes
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="EnableComment"
                        [(ngModel)]="FeedDetails.EnableComment" #EnableComment="ngModel">
                    <label class="form-check-label" for="flexCheckDefault">
                        Enable comments
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="EnableKeepInEmployeesHistory"
                        [(ngModel)]="FeedDetails.EnableKeepInEmployeesHistory" #EnableKeepInEmployeesHistory="ngModel">
                    <label class="form-check-label" for="flexCheckDefault">
                        keep in employees history
                    </label>

                </div>
                <div class="right">
                    <label>Duration : </label>
                    <select name="Duration" [(ngModel)]="FeedDetails.Duration">
                        <option value="1">Day</option>
                        <option value="6">Week</option>
                        <option value="30">Month</option>
                        <option value="365">Always</option>
                    </select>
                </div>

            </div>
            <div class="row">
                <div class="col">

                </div>
                <div class="col-auto">

                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-send"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Post':'Loading...'}}</button>
                </div>
            </div>

        </div>
    </div>
</form>